import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { BillingSubscriptionBodyComponent, BillingSubscriptionWinComponent } from 'sharedFeatures/billing';
import { WindowComponent } from "sharedFeatures/window";
import { ChangePaymentWinBodyComponent } from './change-payment-win-body.component';

@Component({
    selector: 'change-payment-win',
    templateUrl: '../window/window.component.html',
    styleUrls: ['../window/window.component.less']
})
export class ChangePaymentWinComponent extends WindowComponent {
    width = 475;
    height = 270;

    showClose = true;

    title = $localize`CHANGE_PAYMENT_METHOD`;

    cornerRadius = 9;

    modal = true;
    billingComponent: BillingSubscriptionBodyComponent | null = null;
    hostWindow: BillingSubscriptionWinComponent | null = null;

    topMargin = 30;

    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef) {
            
        super(element, r, viewContainerRef, chDet);

        this.windowContentBody = ChangePaymentWinBodyComponent;
        // this.billingComponent = parent; // What is parent?
        this.testId = "Change-payment";
    }
}